import profile from '@/api/customer/profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  customerType: [],
  branch_id: [],
  location_id: [],
  sales: [],
  provinces: [],
  approve_status: undefined,
  sale_id: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CUSTOMER_TYPE(state, data) {
    state.customerType = data
  },
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  },
  SET_LOCATION_ID(state, value) {
    state.location_id = value
  },
  SET_SALE(state, value) {
    state.sales = value
  },
  SET_PROVINCES(state, value) {
    state.provinces = value
  },
  SET_APPROVED_STATUS(state, value) {
    state.approve_status = value
  },
  CLEAR_STATE(state) {
    state.sales = []
    state.provinces = []
  },
  SET_SALE_ID(state, ids) {
    state.sale_id = ids
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        filter: {
          search: context.state.search,
          approve_status: context.state.approve_status,
          sale_id: context.state.sale_id
            ? context.state.sale_id.join(',')
            : undefined
        }
      },
      attrubutes
    )
    return profile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return profile.store(data)
  },
  approveMulti(context, data) {
    return profile.approveMulti(data)
  },
  update(context, { id, data }) {
    return profile.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await profile.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return profile.destroy(id)
  },
  async fetchResources(context) {
    if (!context.state.customerType.length > 0) {
      let type_response = await profile.type()
      context.commit('SET_CUSTOMER_TYPE', type_response.data)
    }

    if (!context.state.sales.length > 0) {
      let sale_response = await profile.sale()
      context.commit('SET_SALE', sale_response.data)
    }

    if (!context.state.provinces.length > 0) {
      let province_response = await profile.province()
      context.commit('SET_PROVINCES', province_response.data)
    }
  },
  async getCustomerType(context) {
    if (!context.state.customerType.length > 0) {
      let type_response = await profile.type()
      context.commit('SET_CUSTOMER_TYPE', type_response.data)
    }
  },
  getDistrict(context, province_code) {
    if (!province_code) return
    return profile.district(province_code)
  },
  getCommune(context, district_code) {
    if (!district_code) return
    return profile.commune(district_code)
  },
  getVillage(context, commune_code) {
    if (!commune_code) return
    return profile.village(commune_code)
  },
  getFormViewModel(context, attributes = {}) {
    return profile.formViewModel({ params: attributes })
  },
  customerExportExcel(context, { ...attributes }) {
    return profile.customerExportExcel(
      Object.assign(
        {
          template: localStorage.getItem('langCode')
            ? localStorage.getItem('langCode')
            : 'en'
        },
        {
          branch_id: context.state.branch_id,
          location_id: context.state.location_id
        },
        attributes
      )
    )
  }
  // customerExportExcel(context, data) {
  //   return profile.customerExportExcel(data)
  // }
}
